import $ from 'jquery';

export class faq {
	
		constructor() {
			$('.js-faq-item').click(function() {
				$(this).find('.js-faq-a').slideToggle();
				$(this).toggleClass('open');
			})

					
			// Fix for accesible click on nav button
			$('.js-faq-item').keypress(function(e) {
				e.preventDefault();
				if ((e.keyCode ? e.keyCode : e.which) == 13) {
					$(this).trigger('click');
				}
			});
		}
	
}

